module.exports = __webpack_public_path__ + "img/uploadTestModal.a8648b68.svg";